<template>
  <v-btn class="text-none"  fab small icon color="grey" @click="$emit('on-click')">
    <v-icon large>mdi-close</v-icon>
  </v-btn>
</template>

<script>
export default {}
</script>
